import React from 'react';
import './MessageBubble.css';

export default function MessageBubble({ message, isOwn }) {
    if (message.isDeleted) {
        return (
            <div className={`bubble-wrapper ${isOwn ? 'own' : ''}`}>
                <div className="bubble bubble-deleted">Сообщение удалено</div>
            </div>
        );
    }

    return (
        <div className={`bubble-wrapper ${isOwn ? 'own' : ''}`}>
            {!isOwn && (
                <div className="bubble-sender">{message.senderName}</div>
            )}
            <div className={`bubble ${isOwn ? 'bubble-own' : 'bubble-other'}`}>
                {message.attachments?.length > 0 && (
                    <div className="bubble-attachments">
                        {message.attachments.map(att => (
                            att.fileType === 'image'
                                ? <img key={att.id} src={att.fileUrl} alt={att.fileName} className="bubble-image" />
                                : (
                                    <a key={att.id} href={att.fileUrl} target="_blank" rel="noreferrer" className="bubble-file">
                                        📎 {att.fileName}
                                    </a>
                                )
                        ))}
                    </div>
                )}
                {message.content && <span className="bubble-text">{message.content}</span>}
                <div className="bubble-footer">
                    <span className="bubble-time">{formatTime(message.sentAt)}</span>
                    {message.isEdited && <span className="bubble-edited">ред.</span>}
                </div>
            </div>
        </div>
    );
}

function formatTime(isoString) {
    const date = new Date(isoString);
    return date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
}
